import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppraisalAssetsModel } from "../../all_Interfaces";


interface InitialState {
    data: AppraisalAssetsModel[],
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: [] as AppraisalAssetsModel[],
    error: '',
    loading: false
}

const appraisalAssetsSlice = createSlice({
    name: "appraisalAssets",
    initialState,
    reducers: {
        updateAppraisalAssets(state, action: PayloadAction<AppraisalAssetsModel[]>) {
            state.data = action.payload;
        },
    },
});

export const { updateAppraisalAssets } = appraisalAssetsSlice.actions;

export default appraisalAssetsSlice.reducer;